/* esm.sh - applesauce-common@5.2.0/dist/helpers/emoji */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/emoji.mjs";
